import { render, staticRenderFns } from "./EditMatch.vue?vue&type=template&id=be5f6f62&scoped=true&"
import script from "./EditMatch.vue?vue&type=script&lang=js&"
export * from "./EditMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5f6f62",
  null
  
)

export default component.exports